import React from "react";
import { useIntl } from "react-intl";

import CloseButton from "../common/CloseButton";

import Modal from "./Modal";

const CustomerConditions = ({ isOpen, close, isBusiness }) => {
	const { formatMessage } = useIntl();

	return (
		<Modal
			isOpen={isOpen}
			onRequestClose={close}
			className="customerConditionsModal"
			aria-labelledby="customerConditionsHeader"
			contentLabel="customerConditionsContent"
			ariaHideApp={false}
		>
			<header className="header" id="customerConditionsHeader">
				<h1 className="title">
					{formatMessage({ id: "komid.register.termsandconditions.title" })}
				</h1>
			</header>
			<CloseButton onClick={close} />
			<div className="content" id="customerConditionsContent">
				<div className="richtext">
					<div
						dangerouslySetInnerHTML={{
							__html: formatMessage({
								id: isBusiness ? "businessCondition" : "privateCondition",
							}),
						}}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default CustomerConditions;
